package com.martdev.flickq.reservation.model

enum class ReservationStatus {
    PENDING, CONFIRMED, CANCELLED
}